{
  "app": {
    "title": "CV & Cover Letter Creator"
  },
  "tabs": {
    "resume": "Resume",
    "coverLetter": "Cover Letter",
    "settings": "Settings"
  },
  "actions": {
    "exportPdf": "Export PDF",
    "downloadPdf": "Download PDF",
    "importJson": "Import JSON",
    "exportJson": "Export JSON",
    "clearAll": "Clear all",
    "clearAllTitle": "Delete all data?",
    "clearAllConfirm": "All entered data (resume, cover letter, design settings) will be permanently deleted. This action cannot be undone.",
    "clearAllCancel": "Cancel",
    "add": "Add",
    "remove": "Remove"
  },
  "basics": {
    "title": "Personal",
    "name": "Name",
    "label": "Job title",
    "email": "Email",
    "phone": "Phone",
    "url": "Website",
    "summary": "Summary",
    "birthDate": "Date of birth",
    "birthPlace": "Place of birth",
    "nationality": "Nationality",
    "image": "Photo",
    "imageUpload": "Upload photo",
    "imageUrlPlaceholder": "or enter image URL",
    "imageRemove": "Remove photo",
    "imageInvalidType": "Please select an image file (PNG, JPEG or WebP).",
    "address": "Street",
    "postalCode": "Postal code",
    "city": "City",
    "countryCode": "Country (ISO)"
  },
  "photo": {
    "shape": "Shape",
    "shape_circle": "Circle",
    "shape_rounded": "Rounded",
    "shape_square": "Square",
    "size": "Size",
    "size_sm": "Small",
    "size_md": "Medium",
    "size_lg": "Large"
  },
  "summary": {
    "description": "Profile summary"
  },
  "work": {
    "position": "Job title",
    "company": "Employer",
    "startDate": "Start date",
    "endDate": "End date",
    "location": "City",
    "currentlyWorking": "Currently working here",
    "description": "Description"
  },
  "education": {
    "degree": "Degree",
    "institution": "Institution",
    "fieldOfStudy": "Field of study",
    "grade": "Grade",
    "startDate": "Start date",
    "endDate": "End date",
    "location": "City",
    "description": "Description"
  },
  "contact": {
    "profiles": "Profiles & Links",
    "network": "Network",
    "username": "Username",
    "profileUrl": "Link (URL)",
    "selectNetwork": "Select network",
    "displayStyle_icons": "Icons only",
    "displayStyle_text": "Text only",
    "displayStyle_both": "Both"
  },
  "skills": {
    "name": "Skill",
    "level": "Level",
    "level_beginner": "Basic Knowledge",
    "level_elementary": "Elementary",
    "level_intermediate": "Intermediate",
    "level_upper_intermediate": "Upper Intermediate",
    "level_advanced": "Advanced",
    "level_proficient": "Proficient",
    "level_expert": "Expert",
    "groupName": "Group",
    "addSkill": "Skill",
    "addGroup": "Group",
    "addChild": "Add skill",
    "childPlaceholder": "e.g. React, Node.js",
    "columns": "Columns"
  },
  "languages": {
    "language": "Language",
    "fluency": "Fluency",
    "fluency_a1": "Elementary",
    "fluency_a2": "Pre-Intermediate",
    "fluency_b1": "Intermediate",
    "fluency_b2": "Upper Intermediate",
    "fluency_c1": "Advanced",
    "fluency_c2": "Near-Native",
    "fluency_native": "Native"
  },
  "projects": {
    "name": "Project name",
    "url": "URL",
    "startDate": "Start date",
    "endDate": "End date",
    "description": "Description",
    "keywords": "Technologies",
    "keywordsPlaceholder": "React, TypeScript, Node.js"
  },
  "certificates": {
    "name": "Certificate name",
    "issuer": "Issuer",
    "date": "Date",
    "url": "URL"
  },
  "interests": {
    "name": "Interest"
  },
  "custom": {
    "sectionTitle": "Section title",
    "itemHeading": "Heading",
    "itemBody": "Content",
    "addItem": "Add entry",
    "addSection": "Add section"
  },
  "coverLetterEditor": {
    "title": "Cover Letter",
    "senderTitle": "Sender",
    "recipientTitle": "Recipient",
    "company": "Company",
    "name": "Name",
    "address": "Address",
    "postalCode": "Postal code",
    "city": "City",
    "country": "Country",
    "email": "Email",
    "phone": "Phone",
    "metaTitle": "Letter Details",
    "place": "Place",
    "date": "Date",
    "subject": "Subject",
    "reference": "Reference / Job ID",
    "referencePlaceholder": "e.g. Your job posting from 01/04/2026, Ref STL-2026-42",
    "bodyTitle": "Letter Body",
    "salutation": "Salutation",
    "salutationPlaceholder": "Dear Sir or Madam,",
    "paragraphs": "Paragraphs",
    "addParagraph": "+ Add paragraph",
    "removeParagraph": "Remove paragraph",
    "closingTitle": "Closing & Signature",
    "closing": "Closing",
    "closingPlaceholder": "Yours sincerely",
    "signatureName": "Name (Signature)",
    "signatureImage": "Signature image",
    "uploadSignature": "Upload signature",
    "removeSignature": "Remove signature",
    "signatureTooLarge": "Image is too large (max 2 MB).",
    "signatureInvalidType": "Please select an image file (PNG, JPEG or WebP).",
    "signatureUploadMode": "Upload",
    "signatureDrawMode": "Draw",
    "signaturePadClear": "Clear",
    "signaturePadApply": "Apply",
    "showFoldMarks": "Show fold and punch marks",
    "showSenderInfo": "Show sender address in information block",
    "din5008Form": "Letter form (DIN 5008)",
    "formA": "Form A — Compact (27mm)",
    "formB": "Form B — Standard (45mm)"
  },
  "sections": {
    "personal": "Personal",
    "summary": "Profile",
    "experience": "Work Experience",
    "education": "Education",
    "skills": "Skills",
    "languages": "Languages",
    "projects": "Projects",
    "certificates": "Certificates",
    "publications": "Publications",
    "awards": "Awards",
    "volunteer": "Volunteering",
    "interests": "Interests",
    "references": "References",
    "custom": "Other"
  },
  "documentTypes": {
    "lebenslauf": "Resume",
    "anschreiben": "Cover Letter",
    "cv": "CV"
  },
  "slots": {
    "sidebar": "Sidebar",
    "main": "Main",
    "header": "Header",
    "footer": "Footer",
    "kopfzeile": "Header",
    "fusszeile": "Footer"
  },
  "editor": {
    "noEntries": "No entries yet.",
    "entry": "entry",
    "entries": "entries",
    "addComponent": "+ Add component",
    "emptySlot": "No components in this area. Add one.",
    "noForm": "No editor available for this component."
  },
  "settings": {
    "uiLocale": "UI language"
  },
  "support": {
    "link": "Support"
  },
  "preview": {
    "page": "page",
    "pages": "pages",
    "rendering": "Rendering…",
    "zoomIn": "Zoom in",
    "zoomOut": "Zoom out",
    "zoomReset": "Reset zoom",
    "showPreview": "Show preview",
    "showEditor": "Show editor"
  },
  "designer": {
    "colors": "Colors",
    "colorPrimary": "Accent",
    "colorSecondary": "Secondary",
    "colorSidebarBg": "Sidebar",
    "colorText": "Text",
    "colorMuted": "Muted",
    "colorBorder": "Border",
    "shuffleColors": "Shuffle colors",
    "palette_navy": "Navy Classic",
    "palette_ocean": "Ocean Blue",
    "palette_cobalt": "Cobalt",
    "palette_steel": "Steel Blue",
    "palette_midnight": "Midnight",
    "palette_slate": "Slate Minimal",
    "palette_charcoal": "Warm Charcoal",
    "palette_graphite": "Graphite",
    "palette_teal": "Deep Teal",
    "palette_forest": "Forest",
    "palette_emerald": "Emerald",
    "palette_sage": "Sage",
    "palette_olive": "Olive",
    "palette_burgundy": "Burgundy",
    "palette_terracotta": "Terracotta",
    "palette_copper": "Copper",
    "palette_sienna": "Sienna",
    "palette_coral": "Coral",
    "palette_espresso": "Espresso",
    "palette_purple": "Royal Purple",
    "palette_indigo": "Indigo",
    "palette_mauve": "Mauve",
    "palette_plum": "Plum",
    "palette_rose": "Rose",
    "palette_airbus": "Airbus",
    "fonts": "Fonts",
    "fontHeading": "Heading",
    "fontBody": "Body",
    "spacing": "Spacing",
    "spacing_compact": "Compact",
    "spacing_normal": "Normal",
    "spacing_spacious": "Spacious",
    "borderStyle": "Border style",
    "sectionTitleStyle": "Title style",
    "titleStyle_uppercase-spaced": "UPPERCASE",
    "titleStyle_normal": "Normal",
    "titleStyle_accent-bar": "Accent bar",
    "titleStyle_accent-underline": "Accent underline",
    "skillDisplay": "Skills display",
    "skillMode_text": "Text",
    "skillMode_bar": "Bar",
    "skillMode_stars": "Stars",
    "skillMode_dots": "Dots",
    "slots": "Sections",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "remove": "Remove",
    "addComponent": "+ Add component"
  },
  "toolbar": {
    "design": "Design",
    "language": "Language",
    "customize": "Customize",
    "customizeTitle": "Customize Design"
  }
}
